const path = require('path');
const contentPath = require('@truqc/content-path');
const momentTimezone = require('moment-timezone');
const lodash = require('lodash');
const sparkMD5 = require('spark-md5');
const _require = require('./common'),
  uuid = _require.uuid,
  uuidV5 = _require.uuidV5;
module.exports = {
  'content-path': contentPath,
  lodash,
  moment: momentTimezone,
  'moment-timezone': momentTimezone,
  path,
  'spark-md5': sparkMD5,
  uuid: {
    v4: uuid,
    v5: uuidV5
  }
};